<template>
  <div class="thematic-add">
    <p class="title">编辑专题</p>
    <el-form
      class="form"
      size="small"
      label-position="right"
      label-width="100px"
      :rules="rules"
      :model="subjectForm"
      ref="subjectForm"
    >
      <el-row>
        <el-col>
          <el-form-item label="专题名称：" prop="subjectName">
            <el-input
              v-model="subjectForm.subjectName"
              placeholder="请输入专题名称"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="专题简介：" prop="subjectDesc">
            <el-input
              v-model="subjectForm.subjectDesc"
              placeholder="请输入专题简介"
              type="textarea"
              :rows="2"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="scale" label="专题排序：" prop="order" required>
            <el-input-number
              v-model="subjectForm.order"
              :min="0"
              :max="100"
              label="描述文字"
            ></el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item class="scale" label="WEB封面：" prop="webCover">
            <div
              v-if="subjectForm.webCover"
              id="video-cover"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="subjectForm.webCover" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer1 = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCover(1)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover1"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label class="upload-text">上传图片</label>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="scale" label="APP封面：" prop="appCover">
            <div
              v-if="subjectForm.appCover"
              id="video-cover"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="subjectForm.appCover" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer2 = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCover(2)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover2"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label class="upload-text">上传图片</label>
            </el-upload>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="scale" label="专题背景：" prop="bgCover">
            <div
              v-if="subjectForm.bgCover"
              id="video-cover"
              @mouseenter="showCover = true"
              @mouseleave="showCover = false"
            >
              <img :src="subjectForm.bgCover" class="avatar" />
              <div v-show="showCover" class="cover-bg">
                <i
                  class="el-icon-zoom-in delete"
                  @click.stop="showViewer3 = true"
                ></i>
                <i
                  class="el-icon-delete delete"
                  @click.stop="deleteCover(3)"
                ></i>
              </div>
            </div>
            <el-upload
              v-else
              action=""
              class="avatar-uploader"
              :show-file-list="false"
              :http-request="uploadCover3"
              accept="png,jpg,jpeg"
              :limit="1"
              ref="coverUpload"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <label class="upload-text">上传图片</label>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item class="form-handle" label-width="0">
            <el-button @click="resetForm">重置</el-button>
            <el-button @click="goBack">返回</el-button>
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-image-viewer
      v-if="showViewer1"
      :on-close="closeViewer(1)"
      :url-list="[subjectForm.webCover]"
    />
    <el-image-viewer
      v-if="showViewer2"
      :on-close="closeViewer(2)"
      :url-list="[subjectForm.appCover]"
    />
    <el-image-viewer
      v-if="showViewer3"
      :on-close="closeViewer(3)"
      :url-list="[subjectForm.bgCover]"
    />
  </div>
</template>

<script>
import { getSubjectInfo, updateSubjectInfo } from "@/api/subjectInfo";
import { Confirm } from "@/components/Confirm";
import { setItem } from '../../../utils/storage';
//import FileHandler from "@/utils/file";

export default {
  name: "videoAdd",
  data() {
    return {
      subjectForm: {
        subjectName: "",
        subjectDesc: "",
        order: 0,
        webCover: "",
        appCover: "",
        bgCover: ""
      },
      checkArray: [],
      questionData: [],
      rules: {},
      showCover: false,
      showViewer1: false,
      showViewer2: false,
      showViewer3: false,
      edituuid: ""
    };
  },
  computed: {
    questionIds() {
      return this.checkArray.map(item => item.uuid);
    }
  },
  created() {
    if (this.$route.query.uuid) {
      getSubjectInfo({ uuid: this.$route.query.uuid }).then(res => {
        if (!res || res.code != 0) return;
        this.subjectForm = res.data;
        this.edituuid = res.data.uuid;
      });
    }
  },
  methods: {
    goBack() {
      this.$router.push('/subjectInfo');
    },
    // 关闭图片预览
    closeViewer(index) {
      this["showViewer" + index] = false;
    },
    // 上传封面
    uploadCover1() {
      let url =
        "https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1585560642&di=c61c62b6ae2b9a946142445b6f1c3fe2&src=http://a0.att.hudong.com/78/52/01200000123847134434529793168.jpg";
      this.subjectForm.webCover = url;
    },
    uploadCover2() {
      let url =
        "https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1585560642&di=c61c62b6ae2b9a946142445b6f1c3fe2&src=http://a0.att.hudong.com/78/52/01200000123847134434529793168.jpg";
      this.subjectForm.appCover = url;
    },
    uploadCover3() {
      let url =
        "https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1585560642&di=c61c62b6ae2b9a946142445b6f1c3fe2&src=http://a0.att.hudong.com/78/52/01200000123847134434529793168.jpg";
      this.subjectForm.bgCover = url;
    },
    // 删除封面
    deleteCover(index) {
      // let filePath = decodeURI(this.videoForm.videoLink.split(".com/")[1]);
      // FileHandler.deleteFile(filePath)
      //   .then(() => {
      //     this.videoForm.coverUrl = "";
      //   })
      //   .catch(e => {
      //     console.log(e);
      //   });
      switch (index) {
        case 1:
          this.subjectForm.webCover = "";
          break;
        case 2:
          this.subjectForm.appCover = "";
          break;
        case 3:
          this.subjectForm.bgCover = "";
          break;
      }
    },
    deepClone(obj) {
      // 先检测是不是数组和Object
      // let isArr = Object.prototype.toString.call(obj) === '[object Array]';
      let isArr = Array.isArray(obj);
      let isJson = Object.prototype.toString.call(obj) === "[object Object]";
      if (isArr) {
        // 克隆数组
        let newObj = [];
        for (let i = 0; i < obj.length; i++) {
          newObj[i] = this.deepClone(obj[i]);
        }
        return newObj;
      } else if (isJson) {
        // 克隆Object
        let newObj = {};
        for (let i in obj) {
          newObj[i] = this.deepClone(obj[i]);
        }
        return newObj;
      }
      // 不是引用类型直接返回
      return obj;
    },
    backAdd() {
      this.addFlag = false;
    },
    async resetForm() {
      const text = "确定重置吗?";
      try {
        await Confirm(text, "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        });
        this.$refs["subjectForm"].resetFields();
      } catch (error) {
        if (error === "cancel") return;
      }
    },
    selectChange(selections) {
      this.checkArray = selections;
    },
    //新增专题
    submit() {
      this.$refs["subjectForm"].validate().then(() => {
        let params = Object.assign({}, this.subjectForm);
        params["onlineStatus"] = 1;
        params["isRecommended"] = 0;
        params["enableShared"] = 1;
        updateSubjectInfo(params).then(res => {
          if (!res || res.code != 0) return;
          setItem(this.REFRESH_FLAG, true);
          this.$message({
            message: "专题编辑成功！",
            type: "success"
          });
          this.goBack();
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.thematic-add {
  $textColor: #51627d;
  $textSize: 14px;
  @mixin text {
    color: $textColor;
    font-size: $textSize;
  }
  /deep/ .el-dialog__body {
    padding: 30px 30px 30px 20px;
  }
  .form {
    padding: 10px 34px;
  }
  .title {
    color: #343c4a;
    font-size: 16px;
    margin: 0;
    padding: 14px 0 10px 34px;
    border-bottom: 1px solid #edf1f8;
  }
  .delete-choose {
    position: absolute;
    top: 10px;
    right: -19px;
    font-size: 14px;
    cursor: pointer;
  }
  /deep/ .el-form-item__label {
    @include text;
  }
  /deep/ .el-radio__label {
    @include text;
    font-weight: normal;
  }
  /deep/ .is-checked .el-radio__label {
    color: #3a85ff;
  }
  /deep/ .scale .el-input {
    @include text;
  }
  .form-select {
    width: 100%;
    &.has-btn {
      width: calc(100% - 120px);
    }
  }
  .button-dept {
    margin-left: 10px;
    width: 100px;
  }
  .progress {
    outline: none;
    border: 1px dashed #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
  }
  .mr30 {
    margin-right: 30px;
  }
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-color: #f7f9fc;
    width: 104px;
    height: 104px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 84px;
    height: 84px;
    line-height: 84px;
    text-align: center;
  }
  .avatar {
    width: 104px;
    height: 104px;
    display: block;
  }
  .upload-text {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    color: $textColor;
    font-size: 13px;
  }
  .progress {
    outline: none;
    border: 1px dashed #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
  }
}
</style>
